import React from 'react'
import { Typography, type TypographyProps, Skeleton, styled } from '@mui/material'
import { GenericLoader } from '../GenericLoader'
import type { LoadingProps } from '../LoadingProps'

const H4Skeleton = styled(Skeleton)`
    height: 40px;
`

interface Props extends LoadingProps, Omit<TypographyProps, 'width'> {
    dataTest?: string
    className?: string
}

export const LoaderH4: React.FC<Props> = ({ loading, width, children, color, dataTest, className }: Props) => {
    return (
        <GenericLoader loading={loading} SkeletonComponent={H4Skeleton} skeletonProps={{ width }}>
            <Typography color={color} className={className} variant="h5" data-test={dataTest}>
                {children}
            </Typography>
        </GenericLoader>
    )
}
